var changeArray = function(version) {
  a = [];
  try {
    parsed = JSON.parse(version.object_changes);
  } catch (e) {
    parsed = {};
  }
  _.each(parsed, function(v, k) {
    if (k !== 'created_at' && k !== 'updated_at') {
      if (_.isArray(v)) {
        a.push(k + ': from ' + (v[0] || 'nothing') + ' to ' + v[1] + '. ');
      } else {
        a.push(k + ': ' + (v || 'nothing') + '.');
      }
    }
  });
  return a;
};

var filter = function() {
  return function(version, join) {
    r = '';
    if (version.event === 'update' || version.meta_action == true) {
      r = changeArray(version);
      if (join) r = _.join(r, '');
    }
    return r;
  };
};

filter.$inject = [];

tiz.filter('changelogString', filter);

var linkMatch = function(version) {
  s = '^.index';
  switch(version.item_type) {
    case 'OrderGroup':
      s = 'layout.orders.shows({orderGroupId: ' + version.item_id + '})';
      break;
    case 'Order':
      if ((version.object || {}).order_group_id) {
        s = 'layout.orders.show_scroll({orderGroupId: ' + version.object.order_group_id + ', orderId: ' + version.item_id + '})';
      }
      break;
    case 'User':
      s = 'layout.users.show({userId: ' + version.item_id + '})';
      break;
    case 'Retailer':
      s = 'layout.retailers.show.profile({retailerId: ' + version.item_id + '})';
      break;
    case 'Inventory':
      s = 'layout.inventories_details({inventoryId: ' + version.item_id + '})';
      break;
    case 'Distributor':
      s = 'layout.distributors.show({distributorId: ' + version.item_id + '})';
      break;
    case 'ProductLine':
      s = 'layout.product_lines.show({productLineId: ' + version.item_id + '})';
      break;
    case 'DistributionArea':
      s = 'layout.distribution_areas.show({distributionAreaId: ' + version.item_id + '})';
      break;
  }
  return s;
};

var filter2 = function() {
  return linkMatch;
};

filter2.$inject = [];

tiz.filter('changelogItemLink', filter2);

var filter3 = function() {
  return function(versions) {
    _.each(versions, function(version) {
      new_result = linkMatch(version);
      if (new_result != '^.index') {
        return new_result;
      }
    });
    return new_result;
  };
};

filter3.$inject = [];

tiz.filter('changelogsItemLink', filter3);
